:host {
    #table-data {
        display: none;
    }

    table {
        border: 0;
        border-top: 1px solid $pl-border-color-primary;
        border-collapse: collapse;
        width: 100%;

        a {
            color: $pl-link-color-primary;
            text-decoration: none;
            &:hover {
                text-decoration: underline;
            }
        }

        th {
            border: 0;
            background-color: $polaris-palette-grey1;
            border-bottom: 1px solid $polaris-palette-grey2;
            vertical-align: top;
            padding: .8em .6em;
            color: $pl-text-color-secondary;
            font-size: $polaris-font-size-2;
            font-weight: $polaris-font-weight-normal;
            text-align: left;

            span, .ti-techdocs-table-header-label {
                clear: both;
            }

            .ti-techdocs-table-header-label {
                padding: 0 0 .6em;
                font-weight: $polaris-font-weight-normal;
            }
        }

        //THEAD for featured icon
        th:nth-of-type(1) {
            width: 20px;
            max-width: 20px !important;
        }
        //THEAD for document type
        th:nth-of-type(2) {
            width: 156px;
        }
        //THEAD for label
        th:nth-of-type(3) {
            width: 520px;
        }
        //THEAD for document download (CN and JP)
        th:nth-of-type(4) {
            width: auto;
        }
        //THEAD for English download
        th:nth-of-type(5) {
            width: 10%;
        }
        //THEAD for date
        th:last-of-type {
            width: 94px;
        }

        .ti-techdocs-table-cell-nowrap {
            white-space: nowrap;
        }

        td:first-child {
            padding: $polaris-space-2 $polaris-space-2 $polaris-space-2 $polaris-space-4;
        }

        td {
            border: 0;
            border-bottom: 1px solid $polaris-palette-grey2;
            line-height: $polaris-line-height-2;
            color: $pl-text-color-primary;
            vertical-align: top;
            padding: .6em;

            @include mix-for-sizes-down(phone) {
                line-height: $polaris-line-height-3;
            }
        }
    }

    .ti-techdocs-pdf-html-separator {
        padding: 0 8px;
    }

    .ti-techdocs-results-button {
        width: 100%;
        padding: 10px 0;
        background: $polaris-palette-grey1;
        color: $pl-link-color-primary;
        font-size: $polaris-font-size-2;
        border: 1px solid $pl-border-color-primary;
        border-radius: 0;
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        cursor: pointer;
        margin-top: -1px;
    }

    .ti-techdocs-table-text-highlight {
        color: #333;
        background-color: $polaris-palette-grey2;
    }

    .ti-techdocs-results-button-icon {
        margin: 0 0 0 10px;
        fill: $pl-link-color-primary;
    }
}

:host(:not(.ti-techdocs-empty)) {
    .ti-techdocs-error {
        display: none;
    }
}

:host(.ti-techdocs-all) {
    .ti-techdocs-results-button {
        display: none;
    }
}

// Phone
:host(.ti-techdocs-phone) {
    th {
        padding-top: $polaris-space-4;
        padding-bottom: $polaris-space-4;
    }

    //THEAD Only show featured icon (column 1) Doctype select (column 2) and blank PDF|HTML heading (column 4) in the header
    th:not(:nth-child(4)):not(:nth-child(2)):not(:nth-child(1)) {
        display: none;
    }

    //TBODY Only show featured icon (column 1) Document title (column 3) and PDF|HTML links (column 4) in the body
    td:not(:nth-child(4)):not(:nth-child(3)):not(:nth-child(1)) {
        display: none;
    }

    //THEAD for featured icon - Saving space on mobile
    th:nth-of-type(1) {
        padding-left: 0;
        width: 16px;
        max-width: 16px;
    }

    //THEAD for document type
    th:nth-of-type(2) {
        width: auto !important;
    }
    //THEAD for document download (CN and JP)
    th:nth-of-type(4) {
        width: 0 !important;
    }
    //THEAD for date
    th:last-of-type {
        width: 0 !important;
    }

    // hide all column header labels
    .ti-techdocs-table-header-label {
        display: none;
    }
}

// Tablet (hide date column)
:host(.ti-techdocs-tablet) {
    //THEAD Hide Date (always last column)
    th:last-child {
        display: none;
    }

    //TBODY Hide date (always last column)
    td:last-child {
        display: none;
    }
}
